import React, { Component } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Route, Switch } from 'react-router-dom';

import ConnectedMemberDetails from './containers/ConnectedMemberDetails';
import ConnectedLandingPage from './containers/ConnectedLandingPage';

import GraphikWOFF from './fonts/Graphik-Regular.woff';

const graphik = {
  fontFamily: 'Graphik',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Graphik'),
    local('Graphik-Regular'),
    url(${GraphikWOFF}) format('woff')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Graphik, Pacifico, Arial',
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [graphik],
      },
    },
  },
});

class App extends Component {
  render() {
    return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
        <Container>
          <Row className="row">
            <Col xs={12}>
              <Switch>
                <Route path="/member-search/:congressId" component={ConnectedLandingPage} />
                <Route path="/members/:personId" component={ConnectedMemberDetails}/>
                <Route path="/" component={ConnectedLandingPage} />
              </Switch>
            </Col>
          </Row>
        </Container>
      </ThemeProvider>
    );
  }
}

export default App;
